import * as React from "react"
import { IconSeekers } from "ui-seeker/core"

export default function PopupSeeker({ isShow=false, controller, type='light', className='', style, children }) {

	const showClass = isShow ? 'show' : ''

	const handleClick = event => {
		event.stopPropagation();
		controller(false)
	}

	const myStyles = {
		width: '377px',
		marginLeft: '-235px',
		...style
	}

	return <div className={`popup ${type}`}>
		<div className={`popup-content ${showClass} ${className}`} style={myStyles}>
			<div className="content-block">
				{children}
			</div>

			<div className="close-block" onClick={handleClick}>
				<IconSeekers className="close-icon" icon="angle-up" iconType="fontAwesome" />
			</div>
		</div>
	</div>
}
